export const VERIFYING_DOMAIN_STATUSES = ["pending", "dns-validation-pending"];
export const FAILED_DOMAIN_STATUSES = ["failed"];
export const SUCCESS_DOMAIN_STATUSES = ["completed"];
export const SUPPORT_SUBJECTS = ["Account", "Constructor", "Premium", "Other"];

export enum DomainType {
  UserSubdomain = 3,
  UserDomain = 4,
  Subdomain = 5,
}

export enum DomainOptionType {
  Domain = "domain",
  Subdomain = "subdomain",
  UserDomain = "userDomain",
  UserSubdomain = "userSubdomain",
}

export enum DomainStepView {
  Default = "default",
  AddDomain = "addDomain",
  Connect = "connect",
  Verifying = "verifying",
}
